import React, { PropTypes } from "react"
import { Nav, Navbar, NavItem, NavDropdown, MenuItem } from "react-bootstrap"
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Link,
  withRouter,
  Switch
} from "react-router-dom"
import { connect } from "react-redux"
import classNames from "classnames"

// LOCAL
import {
  GearIcon,
  CrownIcon,
  HomeIcon,
  HamburgerIcon,
  EverlanceIcon
} from "../icons"
import { logout } from "../../user/actions"
import "./Navigation.css"
import MobileMenu from "../MobileMenu.js"
import SideNav from "../../layout/SideNav"
import { Menu, Dropdown, Icon, message } from "antd"
import AccountMenu from "../../account/menu/Menu"
import { createMatchSelector } from "../../rootReducer"

const mapStateToProps = (state, ownProps) => {
  // const matchSelector = createMatchSelector('/:foo');
  const stepOne = createMatchSelector("/step-one")(state)
  const stepTwo = createMatchSelector("/step-two")(state)
  const stepThree = createMatchSelector("/step-three")(state)
  // // const match = matchSelector(getState());

  return {
    isOnboarding: stepOne || stepTwo || stepThree,
    isEnterpriseOwner: state.account.isEnterpriseOwner,
    isAccountant: state.account.isAccountant,
    email: state.models.user.email,
    isNetworkError: state.models.user.isNetworkError,
    isAuthenticated: state.models.user.isAuthenticated,
    isPremium: state.models.user.isPremium,
    isOpen: state.account.menu.isOpen,
    isMoreOpen: state.account.menu.isMoreOpen,
    trial_days_remaining: state.models.user.customer
      ? state.models.user.customer.trial_days_remaining
      : state.models.user.trial_days_remaining
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    handleLogout: () => dispatch(logout()),
    toggleNav: () => dispatch({ type: "TOGGLE_NAV" }),
    toggleMoreNav: () => dispatch({ type: "TOGGLE_MORE_NAV" })
  }
}
// https://reacttraining.com/react-router/web/example/custom-link
const IconLink = ({
  className,
  label,
  to,
  activeOnlyWhenExact,
  icon: Icon,
  activeColor = "#31B59F"
}) => (
  <Route
    path={to}
    exact={activeOnlyWhenExact}
    children={({ match }) => {
      var divClass = classNames({
        active: match
      })
      return (
        <div className={className + " " + divClass}>
          <Link to={to}>
            {match ? <Icon color={activeColor} /> : <Icon />}
            <span>{label}</span>
          </Link>
        </div>
      )
    }}
  />
)

const DropMenu = ({ isPremium, handleLogout }) => (
  <div className="DropMenu">
    <style>{`
      .ant-dropdown .ant-menu {
        padding: 20px;
        background: #FFFFFF;
        box-shadow: 0 2px 14px 0 rgba(4,25,52,0.14);
        border-radius: 4px;
      }
      .ant-menu a {
        font-size: 16px;
        color: black;
      }
    `}</style>
    <Menu>
      <Menu.Item key="0">
        <a href="http://blog.everlance.com" target="_blank">
          Blog
        </a>
      </Menu.Item>
      <Menu.Item key="1">
        <a href="http://help.everlance.com" target="_blank">
          Help Center
        </a>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="2">
        <a onClick={handleLogout}>Sign out</a>
      </Menu.Item>
    </Menu>
  </div>
)

const TopNav = ({
  isOnboarding,
  isAuthenticated,
  isEnterpriseOwner,
  isAccountant,
  handleLogout,
  email,
  isPremium,
  trial_days_remaining,
  isOpen,
  toggleNav,
  toggleMoreNav,
  isMoreOpen
}) => {
  if (!isAuthenticated) return null

  if (isOnboarding)
    return (
      <div>
        <div className="Navigation">
          <div className="Logo">
            <span style={{ margin: "auto" }}>
              <EverlanceIcon />
            </span>
            {/* <span style={{ display: 'flex', alignItems: 'center', marginLeft: "-70px", marginRight: "30px", fontWeight: 600}}>BETA</span> */}
          </div>
          {email &&
            isOnboarding && (
              <div style={{ alignSelf: "center" }}>Welcome, {email}</div>
            )}
          <div style={{ flexGrow: "1" }} />
        </div>
      </div>
    )

  return (
    <div>
      <div className="Navigation">
        <div className="Hamburger" onClick={toggleNav}>
          <HamburgerIcon />
        </div>

        <div className="Logo">
          <Route
            path="/teams"
            component={() => <div style={{ width: 100 }} />}
          />
          <Route
            path="/account"
            component={() => <div style={{ width: 100 }} />}
          />
          <Link to="/">
            <EverlanceIcon />
          </Link>
          <Route
            path="/account"
            component={() => (
              <h2
                style={{
                  borderRadius: 3,
                  padding: 6,
                  color: "#555",
                  fontSize: 20,
                  margin: "0 20px",
                  alignSelf: "center",
                  fontWeight: 700
                }}
              >
                {" "}
                Account{" "}
              </h2>
            )}
          />
          <Route
            path="/teams"
            component={() => (
              <h2
                style={{
                  borderRadius: 3,
                  padding: 6,
                  color: "#555",
                  fontSize: 20,
                  margin: "0 20px",
                  alignSelf: "center",
                  fontWeight: 700
                }}
              >
                {" "}
                TEAMS DASHBOARD{" "}
              </h2>
            )}
          />
        </div>

        <div className="menu">
          {(!isPremium || trial_days_remaining > 0) && (
            <IconLink
              className="premium-iconlink"
              to="/premium"
              label="Unlock Premium"
              icon={CrownIcon}
            />
          )}

          <Switch>
            <Route path="/teams" component={() => null} />
            <Route
              component={() => (
                <IconLink
                  to="/account/profile"
                  label="Account"
                  icon={GearIcon}
                />
              )}
            />
          </Switch>

          <div>
            <Dropdown
              trigger={["click"]}
              overlay={
                <DropMenu isPremium={isPremium} handleLogout={handleLogout} />
              }
            >
              <a className="ant-dropdown-link">
                <span>
                  More <Icon type="down" />
                </span>
              </a>
            </Dropdown>
          </div>
        </div>

        <div className="More">
          <a className="ant-dropdown-link" onClick={toggleMoreNav}>
            <Icon type="down" />
          </a>
        </div>
      </div>

      <Switch>
        <Route
          path="/account"
          component={() => (
            <MobileMenu menuItems={AccountMenu} isOpen={isOpen} />
          )}
        />
        <Route
          path="/"
          component={() => <MobileMenu menuItems={SideNav} isOpen={isOpen} />}
        />
      </Switch>

      <MobileMenu
        menuItems={() => (
          <div className="MoreNav">
            <div>
              <a href="http://blog.everlance.com" target="_blank">
                <span>Blog</span>
              </a>
            </div>
            <div>
              <a href="http://help.everlance.com" target="_blank">
                <span>Help Center</span>
              </a>
            </div>
            <IconLink to="/account" label="Account" icon={GearIcon} />
            {(!isPremium || trial_days_remaining > 0) && (
              <IconLink to="/premium" label="Unlock Premium" icon={CrownIcon} />
            )}
          </div>
        )}
        isOpen={isMoreOpen}
      />
    </div>
  )
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TopNav)
)



// WEBPACK FOOTER //
// ./src/core/components/Navigation.js